/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'paper-clip': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M1.58 14.393A5.516 5.516 0 010 10.502c0-1.47.56-2.85 1.58-3.89l5.37-5.45a3.846 3.846 0 015.51 0c1.52 1.54 1.52 4.05 0 5.6l-5.37 5.45c-.92.94-2.43.94-3.36 0-.93-.94-.93-2.48 0-3.42l5.36-5.45c.34-.34.89-.34 1.22 0 .34.34.34.89 0 1.23l-5.36 5.46c-.26.26-.26.68 0 .94.25.26.67.26.93 0l5.36-5.45c.85-.86.85-2.26 0-3.13-.85-.86-2.23-.86-3.07 0L2.8 7.853c-.7.71-1.08 1.65-1.08 2.65s.38 1.95 1.08 2.66a3.658 3.658 0 005.22 0l6.51-6.64c.34-.34.88-.34 1.22 0a.9.9 0 010 1.24l-6.87 6.99a5.46 5.46 0 01-3.47 1.25c-1.38 0-2.77-.54-3.83-1.61z" _fill="currentColor"/>'
  }
})
